<template>
  <svg
    :class="classnames"
    :fill="`currentColor`"
    :height="getHeight"
    :viewBox="`0 0 22 22`"
    :width="getWidth"
  >
  <g transform="translate(-410.000000, -236.000000)">
    <g transform="translate(411.000000, 237.000000)">
      <path d="M7.19923496,11.5989786 C8.24198154,12.9930101 9.83878772,13.8654191 11.5752148,13.9897786 C13.3116419,14.1141381 15.0164739,13.4781859 16.247235,12.2469786 L19.2471068,9.24710678 C21.5331215,6.88043847 21.5006024,3.13820313 19.1861997,0.823800342 C16.8717969,-1.49060245 13.1295615,-1.52312146 10.7752882,0.750711794 L9.04495775,2.4708347 C8.65329657,2.86021878 8.65145061,3.49338107 9.0408347,3.88504225 C9.43021878,4.27670343 10.0633811,4.27854939 10.4550422,3.8891653 L12.1750422,2.1791653 C13.7342273,0.673399368 16.2290509,0.69507871 17.7719861,2.2380139 C19.3149213,3.7809491 19.3366006,6.27577266 17.8207118,7.84528821 L14.8328932,10.8328932 C14.0122577,11.6538263 12.875703,12.0777944 11.7180849,11.9948881 C10.5604669,11.9119818 9.49592943,11.3303758 8.80076504,10.4010214 C8.46995831,9.95877109 7.84327174,9.86842822 7.40102142,10.199235 C6.95877109,10.5300417 6.86842822,11.1567283 7.19923496,11.5989786 Z" />
      <path d="M12.800765,8.40102142 C11.7580185,7.00698991 10.1612123,6.13458091 8.4247852,6.01022141 C6.68835813,5.88586191 4.98352608,6.52181407 3.75276504,7.75302142 L0.752893219,10.7528932 C-1.53312146,13.1195615 -1.50060245,16.8617969 0.813800342,19.1761997 C3.12820313,21.4906024 6.87043847,21.5231215 9.22471179,19.2492882 L10.9471068,17.5271068 C11.3376311,17.1365825 11.3376311,16.5034175 10.9471068,16.1128932 C10.5565825,15.7223689 9.92341751,15.7223689 9.53289322,16.1128932 L7.82289322,17.8228932 C6.26577266,19.3266006 3.7709491,19.3049213 2.2280139,17.7619861 C0.68507871,16.2190509 0.663399368,13.7242273 2.17928821,12.1547118 L5.16710678,9.16710678 C5.98774232,8.34617368 7.12429701,7.92220558 8.28191506,8.00511191 C9.43953311,8.08801824 10.5040706,8.66962425 11.199235,9.59897858 C11.5300417,10.0412289 12.1567283,10.1315718 12.5989786,9.80076504 C13.0412289,9.46995831 13.1315718,8.84327174 12.800765,8.40102142 Z" />
    </g>
  </g>
  </svg>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'svg-icon-link'

  export default {
    name: 'SvgIconLink',
    components: {},
    mixins: [ bem ],
    props: {
      height: {
        default: '22',
        type: String
      },
      width: {
        default: '22',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      getHeight: function () {
        const height = `${this.height}px`

        return height
      },
      getWidth: function () {
        const width = `${this.width}px`

        return width
      }
    },
    created: function () {
      this.namespace = namespace
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconLink.vue